import React from 'react'


interface CardpatientsProps {
  label: string;
  icon: React.ReactNode;
  number: string | number;
  linkText: string;
  onLinkClick?: () => void;
}


function Cardpatients({ label, icon, number, linkText, onLinkClick }: CardpatientsProps) {
  return (
    <div style={{ background: "#fff", width: "100%", height: "100%", position: "relative", boxSizing: "border-box", border: "1px solid #E2E8F080", borderRadius: "8px" }}>
      <div style={{
        position: "absolute",
        top: "16px",
        left: "16px",
        fontFamily: 'Quicksand, sans-serif',
        fontWeight: 500,
        fontStyle: 'normal',
        fontSize: '14px',
        lineHeight: '100%',
        letterSpacing: '0%',
        color: '#222',
      }}>{label}</div>
      <div style={{
        position: "absolute",
        top: "16px",
        right: "16px",
      }}>{icon}</div>
      <div style={{
        position: "absolute",
        bottom: "12px",
        left: "16px",
        fontFamily: 'Quicksand, sans-serif',
        fontWeight: 500,
        fontStyle: 'normal',
        fontSize: '24px',
        lineHeight: '100%',
        letterSpacing: '0%',
        color: '#222',
      }}>{number}</div>
      <div
        style={{
          position: "absolute",
          bottom: "4px",
          right: "20px",
          fontFamily: 'Quicksand, sans-serif',
          fontWeight: 500,
          fontStyle: 'normal',
          fontSize: '12px',
          lineHeight: '100%',
          letterSpacing: '0%',
          color: '#1976d2',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
        onClick={onLinkClick}
      >{linkText}</div>
    </div>
  )
}

export default Cardpatients
